/* istanbul ignore file */
import React from "react";
import Tooltip from "./Tooltip/Tooltip";
import Label from "./Label";
import styled from "styled-components";

export const StyledLabelHeaderField = styled.div`
  margin-bottom: 4px;
`;

const LabelHeaderField = ({ id, label, required, toolTip, arrowDirection, isInfo }) => (
  <StyledLabelHeaderField>
    {label && <Label htmlFor={id} name={id} labelText={label} required={required} />}
    {toolTip && <Tooltip title={toolTip} arrowDirection={arrowDirection} isInfo={isInfo} />}
  </StyledLabelHeaderField>
);

export default LabelHeaderField;
